import * as React from 'react';
import classNames from 'classnames';
import Icon from '../Icon';

export interface Option {
  label: string;
  value: unknown;
}

export type UniqOption = {
  label: string;
  value: unknown;
  key: unknown;
};

export interface SelectOptionProps {
  label: string;
  value: unknown;
  selected: boolean;
  isFocused: boolean;
  innerRef?: React.RefCallback<HTMLLIElement>;
  handleOptionClick: (value: Option) => void;
  isMulti?: boolean;
}

function SelectOption(props: SelectOptionProps) {
  const {
    label,
    value,
    isMulti,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    selected,
    innerRef,
    isFocused,
    handleOptionClick,
  } = props;
  const optionClasses = classNames('ui-select-option', {
    'ui-select-option--focused': isFocused,
    'ui-select-option--selected': !isMulti && selected,
  });

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <li
      role="option"
      aria-selected={selected ? 'true' : undefined}
      className={optionClasses}
      ref={innerRef}
      tabIndex={-1}
      onClick={() => {
        handleOptionClick({ value, label });
      }}
    >
      {label}
      {isMulti && selected && (
        <span className="ui-select-icon" aria-hidden={true}>
          <Icon size="xx-small" name="checkmark" />
        </span>
      )}
    </li>
  );
}

export default SelectOption;
